import { useEffect, useState } from "react";

function ScrollButton({pathName}) {
    // 토글 여부를 결정하는 state 선언
  const [toggleBtn, setToggleBtn] = useState(false);
  // window 객체에서 scrollY 값을 받아옴
  // 어느정도 스크롤이 된건지 판단 후, 토글 여부 결정

  const handleScroll = () => {
    const { scrollY } = window;
    scrollY > 200 ? setToggleBtn(true) : setToggleBtn(false);
  };
 
  // scroll 이벤트 발생 시 이를 감지하고 handleScroll 함수를 실행
  useEffect(() => {
    if (pathName === "/index") {
       setToggleBtn(false);
       return;
    } else {
      window.addEventListener("scroll", handleScroll);
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
    
  }, [pathName]);
    const MoveToTop = () => {
        // top:0 >> 맨위로  behavior:smooth >> 부드럽게 이동할수 있게 설정하는 속성
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  return (
    toggleBtn ? (
    <div className="scroll_con">
    <button className="top_btn" onClick={MoveToTop} type="button" />
        {/* Top</button> */}
    </div>
    ): null
  )
}

export default ScrollButton
